enum THEME_ENUM {
	LIGHT = 'light',
	DARK = 'dark',
}

export default THEME_ENUM;
